import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { SearchInstitution } from '@app/models/user';
import { environment } from 'environments/environment';
import { InstitutionType, Institution } from '@app/models/institution';



@Injectable({
  providedIn: 'root'
})
export class InstitutionsService {
  asyncResult: any;
  
  constructor(private http: HttpClient) { }

  getInstitutions(): Observable<any> {
    return this.http.get(environment.apiUrl + 'Institution/GetInstitutionsAsync');
  }

  getInstitutionsBySearch(id: number): Observable<SearchInstitution[]> {
    const result: SearchInstitution[] = [];
    return this.http.get<SearchInstitution[]>('../assets/institutions.json').pipe(map(x => {
      x.forEach(v => {
        if (v.inst_number === id) {
          result.push(v);
        }
      });
      return result;
    }));
  }

  getInstitutionByIdAsync(id: number) {
    return this.http.get<Institution>(environment.apiUrl + 'Institution/GetInstitutionByIdAsync/' + id);
  }

  searchInstitutions(institution: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Institution/SearchInstitutionsAsync', JSON.stringify(institution), httpOptions);
  }

  checkInstitutionNumber(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Institution/InstitutionNumberNotUsed', JSON.stringify(data), httpOptions);
  }

  getInstitutionTypes(): Observable<InstitutionType[]> {
    return this.http.get<InstitutionType[]>(environment.apiUrl + 'Institution/GetInstitutionTypesAsync');
  }

  addInstitution(institution: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const input = {
      Institution: {
        ShortName: institution.shortName,
        InstitutionTypeId: institution.institutionTypeId,
        InstitutionNumber: institution.institutionNumber,
        Name: institution.name,
        OrganizationNumber: institution.organizationNumber,
        visitingAddress: {
          Street: institution.visitingAddress.street,
          City: institution.visitingAddress.city,
          Country: institution.visitingAddress.country
        },
        PaymentAddress: {
          CareOf: institution.paymentAddress.careOf,
          Street: institution.paymentAddress.street,
          ZipCode: institution.paymentAddress.zipCode,
          City: institution.paymentAddress.city,
          Country: institution.paymentAddress.country
        },
        Email: institution.email,
        Phone: institution.phone,
        Swish: institution.swish,
        PhoneMobile: institution.phoneMobile,
        WebSite: institution.webSite,
        StartDate: institution.startDate,
        EndDate: institution.endDate,
        BankAccount1: institution.bankAccount1,
        BankAccount2: institution.bankAccount2,
        InstallationInterval: institution.installationInterval,
        MeetingInterval: institution.meetingInterval,
        Seat: institution.seat
      },
      ParentInstitutionId: institution.parentInstitutionId
    };
    return this.http.post<any>(environment.apiUrl + 'Institution/CreateNewInstitution', JSON.stringify(input), httpOptions);
  }

  IsInstitutionNumberInUse(input: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.put<any>(environment.apiUrl + 'Institution/InstitutionNumberNotUsed', JSON.stringify(input), httpOptions);
  }

  updateInstitution(institution: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.put<any>(environment.apiUrl + 'Institution/UpdateInstitution', JSON.stringify(institution), httpOptions);
  }

  getBLoges(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'Institution/GetInstitutionsByTypeAsync/4');
  }

  SearchMemberFromInstitutionByNameOrId(searchobject: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Member/SearchMemberFromInstitutionByNameOrId', JSON.stringify(searchobject), httpOptions);
  }

  getInstitutionNameInfoAsync(institutionId): Observable<any> {
    return this.http.get(environment.apiUrl + 'Institution/GetInstitutionNameInfoAsync/' + parseInt(institutionId, 10));
  }

  getInstitutionMatrix(institutionId): Observable<any> {
    return this.http.get(environment.apiUrl + 'Institution/GetInstitutionMatrix/' + institutionId);
  }

  SearchMembersForCampAsync(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Member/SearchMembersForCampAsync', JSON.stringify(data), httpOptions);

  }

    SearchMembersForAssociationAsync(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Member/SearchMembersForAssociationAsync', JSON.stringify(data), httpOptions);

  }

  SearchMembersForSLAsync(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Member/SearchMembersForSLAsync', JSON.stringify(data), httpOptions);
  }


  GetAllCampsAndAssociationsAsync(camptype: number) {
    return this.http.get<any>(environment.apiUrl + 'Institution/GetAllCampsAndAssociationsAsync/' + camptype);
  }

  GetAllPrimaryLodgesAsync(camptype: number) {
    return this.http.get<any>(environment.apiUrl + 'Institution/GetAllPrimaryLodgesAsync/' + camptype);
  }

  GetInstitutionReportAsync(searchdata: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Institution/GetInstitutionReportAsync', JSON.stringify(searchdata), httpOptions);
  }

  GetInstitutionChildren(institutionid: number) {
    return this.http.get<any>(environment.apiUrl + 'Institution/GetInstitutionChildren/' + institutionid);
  }

  GetInstitutionParent(institutionid: number) {
    return this.http.get<any>(environment.apiUrl + 'Institution/GetInstitutionParent/' + institutionid);
  }

  GetAllInstitutionsByInstitutionType(input: any) {
    return this.http.get<any>(environment.apiUrl + 'Institution/GetAllInstitutionsByInstitutionType/' + input);
  }

  GetFeesPerInstitutionAndYear(feereportdata: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Fee/GetFeesPerInstituionAndYear', feereportdata, httpOptions);
  }

  getEntryExitCauses() {
    return this.http.get<any>(environment.apiUrl + 'Institution/GetEntryExitCauses');
  }

  GetAllInstitutionsExceptLodges(subset: number) {
    return this.http.get<any>(environment.apiUrl + 'Institution/GetAllInstitutionsExceptLodges/' + subset);
  }

  GetCurrentCampOrAssociationsByMemberIdAsync(memberid: number) {
    return this.http.get<any>(environment.apiUrl + 'Membership/GetCurrentCampOrAssociationsByMemberIdAsync/' + memberid);
  }

  GetInstitutionsPerDistrictReport(subset: number) {
    return this.http.get<any>(environment.apiUrl + 'Institution/GetInstitutionsPerDistrictReport/' + subset);
  }

  GetChargingList(date: string) {
    return this.http.get<any>(environment.apiUrl + 'Report/GetChargingList/' + date);
  }

  GetAllDistrictsAsync(subset: number) {
    return this.http.get<any>(environment.apiUrl + 'Institution/GetAllDistrictsAsync/' + subset);
  }

  GetAllCampsAsync(subset: number) {
    return this.http.get<any>(environment.apiUrl + 'Institution/GetAllCampsAsync/' + subset);
  }

  GetInstitutionGroupNameByInstitutionId(institutionid: number) {
    return this.http.get<any>(environment.apiUrl + 'Institution/GetInstitutionGroupNameByInstitutionId/' + institutionid);
  }

  GetAllDistricts() {
    return this.http.get<any>(environment.apiUrl + 'Institution/GetAllDistricts');
  }

  GetAllInstitutionIDsFromDistrict(input: any) {
    return this.http.get<any>(environment.apiUrl + 'Institution/GetAllInstitutionIDsFromDistrict/' + input);
  }

  CreateInstitutionMatrixReportForDownload(params: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Institution/CreateInstitutionMatrixReportForDownload', JSON.stringify(params), httpOptions);
  }

  CreateInstitutionLabelMatrixReportForDownload(params: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<any>(environment.apiUrl + 'Institution/CreateInstitutionLabelMatrixReportForDownload', JSON.stringify(params), httpOptions);
   // return this.http.post<any>(environment.apiUrl + 'Institution/GetInstitutionLabelMatrix', JSON.stringify(params), httpOptions);
  }

  GetSLLists() {
    return this.http.get<any>(environment.apiUrl + 'SLListFiles/GetFiles');
  }

  download(id: string) {
  return this.http.get(
    environment.apiUrl + 'SLListFiles/Download/' + id,
    {
      responseType: 'blob'
    }
  );
}

}
